import { LectureSort } from '@/enums/LectureSort';

export const lectureSortingOptions = [
  {
    label: 'relevance',
    value: LectureSort.Relevance,
  },
  {
    label: 'releaseDate',
    value: `-${LectureSort.HeldAt}`,
  },
  {
    label: 'viewCount',
    value: `-${LectureSort.ViewCount}`,
  },
  {
    label: 'alphabeticallyAZ',
    value: LectureSort.Title,
  },
  {
    label: 'alphabeticallyZA',
    value: `-${LectureSort.Title}`,
  },
];
